import React, { useState } from 'react';
import Header from '../partials/header'
import Footer from '../partials/footer'
import { Outlet } from 'react-router-dom'
import useSaasAccount from '../../hooks/useSaasAccount';

const MainLayout = () => {
    const { isOwner } = useSaasAccount()
    const [showTrackOrder, setShowTrackOrder] = useState(false);

    return (
        <>
            <Header setShowTrackOrder={setShowTrackOrder}/>
            <Outlet context={[showTrackOrder, setShowTrackOrder]}/>
            {
                isOwner
                &&
                <Footer />
            }
        </>
    )
}

export default MainLayout